/**
 * DONOTUSEInternalLocalisation.ts
 * @author Diao Zheng
 * @file A specific version of Localisation registry used for internal purposes.
 * @barrel export all
 */
import React from "react";
import * as Localisation from "./Localisation";
const ENGLISH = Localisation.DEFAULT_LANGUAGE;
Localisation.addLanguage("zh", undefined, ENGLISH);
export const DEFAULT_LANGUAGE = "en-US";
let currentLanguage = ENGLISH;
function internalLanguageMapping(language) {
    return language;
}
function externalLanguageMapping(f) {
    return f;
}
export function updateResource(language, resource) {
    Localisation.updateResource(internalLanguageMapping(language), resource);
}
export function setLanguage(language) {
    currentLanguage = internalLanguageMapping(language);
}
export function l(key, ...replacements) {
    return Localisation.getStringFromLanguage(currentLanguage, key, ...replacements);
}
export function getStringFromLanguage(language, key, ...replacements) {
    return Localisation.getStringFromLanguage(internalLanguageMapping(language), key, ...replacements);
}
export function getRandomString(key) {
    return Localisation.getRandomStringFromLanguage(currentLanguage, key);
}
export function convertDate(date, format) {
    return convertDateWithLanguage(externalLanguageMapping(currentLanguage), date, format);
}
export function convertDateWithLanguage(language, date, format) {
    switch (language) {
        case "en-US":
        case "zh":
            return Localisation.convertDateWithLanguage(internalLanguageMapping(language), date, format);
        default:
            return "Invalid Date";
    }
}
export function localisedDefault(value, fallbackKey, ...fallbackReplacements) {
    Localisation.localisedDefault(currentLanguage, value, fallbackKey, ...fallbackReplacements);
}
export const Context = Localisation.Context;
export function l_(key, ...replacements) {
    return React.createElement(Context.Consumer, null, (language) => {
        return getStringFromLanguage(language, key, ...replacements);
    });
}
export function* getAllBundledLanguage() {
    for (const internalLanguage of Localisation.getAllBundledLanguage()) {
        yield externalLanguageMapping(internalLanguage);
    }
}
export function registeredLanguage(language) {
    return internalLanguageMapping(language);
}
